__turbopack_context__.v({
  "root": "AnimatedTextSection-module__Nc3K-a__root",
});
